export enum Role {
  Admin = "Admin",
  CMAdmin = "CMAdmin",
  NonExistant = "NonExistant"
}
